export enum ProductType {
  Product = 'PRODUCT',
  Box = 'BOX',
}
